<template>
    <v-dialog v-model="modalState">
        <template v-slot:activator="{ on, attrs }">
             <v-btn color="default" v-bind="attrs" v-on="on">
                <v-icon small>mdi-plus</v-icon>
                <span v-if="$vuetify.breakpoint.mdAndUp" class="ml-2">{{ $page.props.lang.add_exercises || "Add Exercises" }}</span>
            </v-btn>
        </template>
        <template v-slot:default="dialog">
        <v-card>
            <v-toolbar elevation="0">
                <v-toolbar-title>Exercises</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog.value = false"> 
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text >
                <v-list>
                    <v-list-item-group v-model="selectedItems" color="primary" multiple>
                        <v-list-item v-for="(exercise, i) in exercises" :key="i" @click="toggleSelection(i)" >
                            <v-list-item-content>
                                <v-list-item-title>{{exercise.name}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
               </v-list>

               <v-skeleton-loader v-if="loading"
                class="mx-auto"
                type="list-item-three-line"
                ></v-skeleton-loader>
             </v-card-text>
             <v-card-actions>
                 <v-spacer></v-spacer>
                 <v-btn color="primary" @click="add()">Add Exercises</v-btn>
             </v-card-actions>
        </v-card>
        </template>
    </v-dialog>  
</template>

<script>

import EventBus from '@/js/eventbus'
//https://www.codeply.com/p/YsObsqyMKd
export default {
    props:{
        group: Number
    },
    data(){
        return{
            modalState: false,
            selectedItems: [],
            selectedExercises: [],
            exercises:[],
            loading: false
        }
    },
    watch: {
        modalState:{
            handler (val, oldVal) {
                if(val){
                    this.loadExercises();
                   
                    this.selectedItems = [];
                    this.selectedExercises = [];
                }
            }
        }
    },
    created(){
        
    },
    methods:{

        loadExercises(){
            this.loading = true;
            this.exercises = [];
            axios.get('/backoffice/exercises/lookup')
                .then(response => {
                    console.log(response);
                    this.exercises = response.data;
                     this.loading = false;
                })
        },
        toggleSelection(idx){
         
            this.selectedExercises.push(this.exercises[idx].id);
        },
        
        add(){
           this.modalState = false;
            EventBus.$emit('WORKOUT_SELECTED_EXERCISES', {e: this.selectedExercises});
        }
    }
}
</script>
